import Reveal from 'reveal.js';

// ==========================================
// 1. INISIALISASI REVEAL.JS
// ==========================================
const deck = new Reveal({
  hash: true,
  respondToHashChanges: true,
  history: true,
  controls: true,
  progress: true,
  center: true,
  transition: 'slide', // fade | slide | convex | concave | zoom
  transitionSpeed: 'default',
  
  // Penyesuaian dimensi slide agar pas di berbagai monitor
  width: 960,
  height: 700,
  margin: 0.04,
  minScale: 0.2,
  maxScale: 2.0
});

deck.initialize().then(() => {
  console.log('Reveal.js successfully initialized!');
  updateFixedHeader(deck.getState().indexh);
});

// ==========================================
// 2. KELOLA FIXED HEADER (LOGO STIKMA)
// ==========================================
const fixedHeader = document.getElementById('fixed-header');

function updateFixedHeader(slideIndex) {
  if (!fixedHeader) return;
  
  // Jika di slide Cover (indexh == 0), sembunyikan header
  if (slideIndex === 0) {
    fixedHeader.classList.add('hidden');
  } else {
    fixedHeader.classList.remove('hidden');
  }
}

// Dengarkan event perpindahan slide
deck.on('slidechanged', event => {
  updateFixedHeader(event.indexh);
});

// ==========================================
// 3. INTERAKSI SLIDE 2: PENDAHULUAN (TABS)
// ==========================================
const tabButtons = document.querySelectorAll('.tab-btn');
const tabPanels = document.querySelectorAll('.tab-panel');

tabButtons.forEach(btn => {
  btn.addEventListener('click', () => {
    // Nonaktifkan semua button & panel
    tabButtons.forEach(b => b.classList.remove('active'));
    tabPanels.forEach(p => p.classList.remove('active'));
    
    // Aktifkan button yang diklik
    btn.classList.add('active');
    
    // Cari panel yang sesuai dan aktifkan
    const targetTabId = btn.getAttribute('data-tab');
    const targetPanel = document.getElementById(`panel-${targetTabId}`);
    if (targetPanel) {
      targetPanel.classList.add('active');
    }
  });
});

// ==========================================
// 4. INTERAKSI SLIDE 3: RUMUSAN MASALAH & TUJUAN
// ==========================================
const rumusanCards = document.querySelectorAll('.rumusan-card');
const tujuanCards = document.querySelectorAll('.tujuan-card');
const tujuanPlaceholder = document.getElementById('tujuan-placeholder');

function selectRumusan(targetId) {
  // Nonaktifkan semua rumusan card
  rumusanCards.forEach(c => {
    if (c.getAttribute('data-target') === targetId) {
      c.classList.add('active');
    } else {
      c.classList.remove('active');
    }
  });
  
  // Sembunyikan placeholder
  if (tujuanPlaceholder) {
    tujuanPlaceholder.classList.add('hidden');
  }
  
  // Kunci kembali semua kartu tujuan dan buka yang bersesuaian
  tujuanCards.forEach(tujuan => {
    const id = tujuan.getAttribute('id');
    if (id === `tujuan-${targetId}`) {
      tujuan.classList.add('unlocked');
      tujuan.classList.remove('locked');
    } else {
      tujuan.classList.remove('unlocked');
      tujuan.classList.add('locked');
    }
  });
}

// Set default rumusan 1 saat halaman diinisialisasi
document.addEventListener('DOMContentLoaded', () => {
  selectRumusan('1');
});

rumusanCards.forEach(card => {
  card.addEventListener('click', () => {
    const targetId = card.getAttribute('data-target');
    selectRumusan(targetId);
  });
});

// ==========================================
// 5. INTERAKSI SLIDE 4: METODE PENELITIAN (TIMELINE)
// ==========================================
const timelineNodes = document.querySelectorAll('.timeline-node');
const stepDetails = document.querySelectorAll('.step-detail-content');

timelineNodes.forEach(node => {
  node.addEventListener('click', () => {
    // Nonaktifkan semua node & detail content
    timelineNodes.forEach(n => n.classList.remove('active'));
    stepDetails.forEach(d => d.classList.add('hidden'));
    
    // Aktifkan node yang diklik
    node.classList.add('active');
    
    // Cari detail box yang sesuai
    const stepName = node.getAttribute('data-step');
    const targetDetail = document.getElementById(`detail-${stepName}`);
    if (targetDetail) {
      targetDetail.classList.remove('hidden');
    }
  });
});

// ==========================================
// 6. INTERAKSI SLIDE 5: IMPLEMENTASI (FLIP CARDS) & AVATAR LIGHTBOX
// ==========================================
const flipCards = document.querySelectorAll('.flip-card');
const charImages = document.querySelectorAll('.char-image-wrapper');

flipCards.forEach(card => {
  card.addEventListener('click', (e) => {
    // Toggle flip class
    card.classList.toggle('flipped');
  });
});

charImages.forEach(wrapper => {
  wrapper.addEventListener('click', (e) => {
    e.stopPropagation(); // Mencegah kartu berputar/flip saat foto diklik
    
    const img = wrapper.querySelector('img');
    if (img && lightbox && lightboxImg) {
      lightboxImg.src = img.src;
      if (lightboxCaption) {
        lightboxCaption.textContent = `Ilustrasi Karakter: ${img.alt || 'Karakter'}`;
      }
      lightbox.classList.remove('hidden');
    }
  });
});

// ==========================================
// 7. INTERAKSI SLIDE 6: ASSEMBLY (WORKSPACE GALLERY)
// ==========================================
const thumbnails = document.querySelectorAll('.thumb-card');
const mainPreviewImg = document.getElementById('timeline-main-view');
const mainPreviewCaption = document.querySelector('.workspace-main-preview .caption');

thumbnails.forEach(thumb => {
  thumb.addEventListener('click', () => {
    // Nonaktifkan thumbnail lain
    thumbnails.forEach(t => t.classList.remove('active'));
    
    // Aktifkan thumbnail yang diklik
    thumb.classList.add('active');
    
    // Ambil data gambar & caption
    const newImgSrc = thumb.getAttribute('data-img');
    const newCaption = thumb.getAttribute('data-caption');
    
    // Update preview utama dengan animasi fade-in sederhana
    if (mainPreviewImg && newImgSrc) {
      mainPreviewImg.style.opacity = '0.3';
      setTimeout(() => {
        mainPreviewImg.src = newImgSrc;
        mainPreviewImg.style.opacity = '1';
      }, 150);
    }
    
    if (mainPreviewCaption && newCaption) {
      mainPreviewCaption.textContent = newCaption;
    }
  });
});

// ==========================================
// 8. INTERAKSI SLIDE 7: PENGUJIAN (SIMULASI LIKERT)
// ==========================================
const likertBtns = document.querySelectorAll('.likert-btn');
const likertPercentVal = document.getElementById('likert-percent-val');
const likertDescVal = document.getElementById('likert-desc-val');
const likertProgressFill = document.getElementById('likert-progress-fill');

// Map skor ke persentase & deskripsi kustom untuk demo interaktif
const likertScoresMap = {
  '1': { percent: '15.4%', desc: 'Sangat Kurang Layak (Tidak layak disebarluaskan)' },
  '2': { percent: '38.2%', desc: 'Kurang Layak (Perlu revisi total)' },
  '3': { percent: '56.8%', desc: 'Cukup Layak (Bisa digunakan dengan revisi minor)' },
  '4': { percent: '78.4%', desc: 'Layak (Sesuai kriteria dengan respons positif)' },
  '5': { percent: '94.6%', desc: 'Sangat Layak (Kualitas tinggi & sangat direkomendasikan)' }
};

likertBtns.forEach(btn => {
  btn.addEventListener('click', () => {
    // Nonaktifkan semua button
    likertBtns.forEach(b => b.classList.remove('active'));
    
    // Aktifkan button yang diklik
    btn.classList.add('active');
    
    // Dapatkan skor terpilih
    const score = btn.getAttribute('data-score');
    const data = likertScoresMap[score];
    
    if (data) {
      // Update nilai persentase, deskripsi, dan lebar progress bar
      if (likertPercentVal) likertPercentVal.textContent = data.percent;
      if (likertDescVal) likertDescVal.textContent = data.desc;
      if (likertProgressFill) likertProgressFill.style.width = data.percent;
    }
  });
});

// ==========================================
// 9. INTERAKSI LIGHTBOX PREVIEW (ZOOM & PAN INTERAKTIF)
// ==========================================
const lightbox = document.getElementById('image-lightbox');
const lightboxImg = document.getElementById('lightbox-img');
const lightboxCaption = document.getElementById('lightbox-caption');
const lightboxClose = document.querySelector('.lightbox-close');

function closeLightbox() {
  if (lightbox) {
    lightbox.classList.add('hidden');
  }
  if (lightboxImg) {
    lightboxImg.classList.remove('zoomed');
    lightboxImg.style.transform = '';
    lightboxImg.style.transformOrigin = 'center center';
    lightboxImg.style.cursor = 'zoom-in';
  }
}

if (mainPreviewImg && lightbox && lightboxImg) {
  mainPreviewImg.style.cursor = 'zoom-in';
  mainPreviewImg.addEventListener('click', () => {
    lightboxImg.src = mainPreviewImg.src;
    if (lightboxCaption && mainPreviewCaption) {
      lightboxCaption.textContent = mainPreviewCaption.textContent;
    }
    lightbox.classList.remove('hidden');
  });
}

if (lightbox) {
  lightbox.addEventListener('click', (e) => {
    // Tutup jika mengklik area overlay luar (bukan gambar) atau tombol close
    if (e.target !== lightboxImg && e.target !== lightboxClose) {
      closeLightbox();
    }
  });

  if (lightboxClose) {
    lightboxClose.addEventListener('click', () => {
      closeLightbox();
    });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !lightbox.classList.contains('hidden')) {
      closeLightbox();
    }
  });
}

if (lightboxImg) {
  // Toggle Zoom saat mengklik gambar di dalam lightbox
  lightboxImg.addEventListener('click', (e) => {
    e.stopPropagation(); // Mencegah lightbox langsung tertutup
    lightboxImg.classList.toggle('zoomed');
    
    if (lightboxImg.classList.contains('zoomed')) {
      lightboxImg.style.cursor = 'zoom-out';
      // Atur titik zoom awal sesuai posisi klik
      const rect = lightboxImg.getBoundingClientRect();
      const xPercent = ((e.clientX - rect.left) / rect.width) * 100;
      const yPercent = ((e.clientY - rect.top) / rect.height) * 100;
      lightboxImg.style.transformOrigin = `${xPercent}% ${yPercent}%`;
    } else {
      lightboxImg.style.cursor = 'zoom-in';
      lightboxImg.style.transformOrigin = 'center center';
    }
  });

  // Fitur Panning: geser titik transform origin mengikuti kursor saat dizoom
  lightboxImg.addEventListener('mousemove', (e) => {
    if (!lightboxImg.classList.contains('zoomed')) return;
    
    const rect = lightboxImg.getBoundingClientRect();
    const xPercent = ((e.clientX - rect.left) / rect.width) * 100;
    const yPercent = ((e.clientY - rect.top) / rect.height) * 100;
    
    lightboxImg.style.transformOrigin = `${xPercent}% ${yPercent}%`;
  });
}

// ==========================================
// 10. INTERAKSI MODAL RUMUS ANALISIS (SUGIYONO LIKERT)
// ==========================================
const btnShowRumus = document.getElementById('btn-show-rumus');
const rumusModal = document.getElementById('rumus-modal');
const rumusModalClose = document.getElementById('rumus-modal-close');

function closeRumusModal() {
  if (rumusModal) {
    rumusModal.classList.add('hidden');
  }
}

if (btnShowRumus && rumusModal) {
  btnShowRumus.addEventListener('click', (e) => {
    e.stopPropagation();
    rumusModal.classList.remove('hidden');
  });
}

if (rumusModal) {
  rumusModal.addEventListener('click', (e) => {
    const modalCard = rumusModal.querySelector('.modal-card');
    if ((modalCard && !modalCard.contains(e.target)) || e.target === rumusModalClose) {
      closeRumusModal();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !rumusModal.classList.contains('hidden')) {
      closeRumusModal();
    }
  });
}

// ==========================================
// 11. INTERAKSI MODAL DETAIL SKOR AHLI MATERI
// ==========================================
const btnScoreMateri = document.getElementById('btn-score-materi');
const scoreMateriModal = document.getElementById('score-materi-modal');
const scoreMateriClose = document.getElementById('score-materi-close');

function closeScoreMateriModal() {
  if (scoreMateriModal) {
    scoreMateriModal.classList.add('hidden');
  }
}

if (btnScoreMateri && scoreMateriModal) {
  btnScoreMateri.addEventListener('click', (e) => {
    e.stopPropagation();
    scoreMateriModal.classList.remove('hidden');
  });
}

if (scoreMateriModal) {
  scoreMateriModal.addEventListener('click', (e) => {
    const modalCard = scoreMateriModal.querySelector('.modal-card');
    if ((modalCard && !modalCard.contains(e.target)) || e.target === scoreMateriClose) {
      closeScoreMateriModal();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !scoreMateriModal.classList.contains('hidden')) {
      closeScoreMateriModal();
    }
  });
}

// ==========================================
// 12. INTERAKSI MODAL DETAIL SKOR AHLI MEDIA
// ==========================================
const btnScoreMedia = document.getElementById('btn-score-media');
const scoreMediaModal = document.getElementById('score-media-modal');
const scoreMediaClose = document.getElementById('score-media-close');

function closeScoreMediaModal() {
  if (scoreMediaModal) {
    scoreMediaModal.classList.add('hidden');
  }
}

if (btnScoreMedia && scoreMediaModal) {
  btnScoreMedia.addEventListener('click', (e) => {
    e.stopPropagation();
    scoreMediaModal.classList.remove('hidden');
  });
}

if (scoreMediaModal) {
  scoreMediaModal.addEventListener('click', (e) => {
    const modalCard = scoreMediaModal.querySelector('.modal-card');
    if ((modalCard && !modalCard.contains(e.target)) || e.target === scoreMediaClose) {
      closeScoreMediaModal();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !scoreMediaModal.classList.contains('hidden')) {
      closeScoreMediaModal();
    }
  });
}

// ==========================================
// 13. ZOOM PREVIEW UNTUK GRAFIK TIKTOK (ZOOMABLE IMAGE LISTENER)
// ==========================================
const zoomableImages = document.querySelectorAll('.zoomable-img');

zoomableImages.forEach(img => {
  img.addEventListener('click', (e) => {
    e.stopPropagation();
    if (lightbox && lightboxImg) {
      lightboxImg.src = img.src;
      if (lightboxCaption) {
        lightboxCaption.textContent = img.alt || 'Statistik TikTok';
      }
      lightbox.classList.remove('hidden');
    }
  });
});
